import React, { Component } from 'react'
import { ReactComponent as Chat } from './chat.svg'
import { ReactComponent as Video } from './video.svg'
import { ReactComponent as Search } from './search.svg'
import { ReactComponent as Productivity } from './clock.svg'
import { ReactComponent as Integrations } from './integrations.svg'
import Button from './Button'
import { extendParentClass } from '../../../../utils/classes'

export class Buttons extends Component {
  baseClass = extendParentClass.bind(this)('buttons')

  buttons = [
    {
      children: 'Instant Conversations',
      Icon: Chat,
    },
    {
      children: 'Video Calls',
      Icon: Video,
    },
    {
      children: 'Powerful Search',
      Icon: Search,
    },
    {
      children: 'Productivity Tools',
      Icon: Productivity,
    },
    {
      children: 'App Integrations',
      Icon: Integrations,
    },
  ]

  renderButtons = () => {
    const { setSlide, slide } = this.props
    return this.buttons.map((buttonData, index) => (
      <Button
        {...buttonData}
        key={index}
        index={index}
        setSlide={setSlide}
        parentClass={this.baseClass}
        slide={slide}
      />
    ))
  }

  render() {
    return <ul className={this.baseClass}>{this.renderButtons()}</ul>
  }
}

export default Buttons
